import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import classnames from 'classnames';

import { Intl } from 'components';

export default ( {
  data, success, error, isLoading,
} ) => (
  <Container
    fluid
    className={classnames( 'mt-4', { 'app-component-loading': isLoading } )}
  >
    {!error && !success && 'Wait...'}
    {error && !success
    && (
    <span className="invalid-feedback d-block text-md">
      <Intl id={error} />
    </span>
    )}
    {!!success && !error && (
      <div className="text-center mt-5">
        <img src={data.crmLogo} alt={data.crmName} width={200} />
        <h1 className="text-mp-orange-1 mt-2">
          <Intl id="connectionCompleted" values={{ plugin: data.crmName }} />
        </h1>
        <Link
          className="btn btn-app-sm btn-app-default font-weight-700 mt-4"
          to="/out/new-campaign"
        >
          <Intl id="startUsingMp" />
        </Link>
      </div>
    )}
  </Container>
);
